<template>
  <div>
    <van-swipe :autoplay="3000" indicator-color="white" :height="300">
      <van-swipe-item
        v-for="(image, index) in images"
        :key="index">
        <img v-lazy="image" />
      </van-swipe-item>
    </van-swipe>
    <van-grid :column-num="2">
      <van-grid-item
        v-for="value in 4"
        :key="value"
        icon="photo-o"
        text="文字"
      />
    </van-grid>
    <van-card
      tag="会员"
      price="5.00"
      desc="各位好：这种感觉很奇妙，想走失的旅人重返归途，像擦肩的情人再续前缘"
      title="能点燃我的只有我自己"
      thumb="http://192.168.50.101:8000/media/uploads/img/2019/11/23/IMG_3166.PNG"
      origin-price="10.00"
    >
      <div slot="footer">
        <van-button
          size="small"
          @click="preview(2, $event)"
        >
          试听
        </van-button>
        <van-button size="small">购买</van-button>
      </div>
    </van-card>
    <van-card
      tag="会员"
      price="5.00"
      desc="各位好：这种感觉很奇妙，想走失的旅人重返归途，像擦肩的情人再续前缘"
      title="能点燃我的只有我自己"
      thumb="http://192.168.50.101:8000/media/uploads/img/2019/11/23/IMG_3166.PNG"
      origin-price="10.00"
    >
      <div slot="footer">
        <van-button size="small">试听</van-button>
        <van-button size="small">购买</van-button>
      </div>
    </van-card>
    <van-card
      tag="会员"
      price="5.00"
      desc="各位好：这种感觉很奇妙，想走失的旅人重返归途，像擦肩的情人再续前缘"
      title="能点燃我的只有我自己"
      thumb="http://192.168.50.101:8000/media/uploads/img/2019/11/23/IMG_3166.PNG"
      origin-price="10.00"
    >
      <div slot="footer">
        <van-button size="small">试听</van-button>
        <van-button size="small">购买</van-button>
      </div>
    </van-card>
    <van-tabbar v-model="active" safe-area-inset-bottom>
      <van-tabbar-item icon="home-o">最新</van-tabbar-item>
      <van-tabbar-item icon="fire-o">公播节目</van-tabbar-item>
      <van-tabbar-item icon="gem-o">会员节目</van-tabbar-item>
      <van-tabbar-item icon="like-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem } from 'vant'
import { Swipe, SwipeItem } from 'vant'
import { Lazyload } from 'vant'
import { Grid, GridItem } from 'vant'
import { Card } from 'vant'
import { Button } from 'vant'
Vue.use(Tabbar).use(TabbarItem)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Lazyload)
Vue.use(Grid).use(GridItem)
Vue.use(Card)
Vue.use(Button)

export default {
  data () {
    return {
      active: 0,
      images: [
        'https://img.yzcdn.cn/vant/apple-1.jpg',
        'https://img.yzcdn.cn/vant/apple-2.jpg'
      ]
    }
  },
  methods: {
    preview: function (episodeId, event) {
      window.console.log(event)
      window.console.log("episodeId：")
      window.console.log(episodeId)
      // this.$router.replace("/episode/" + episodeId + '/')
      this.$router.replace({
        name: `EpisodeDetail`,
        params: {
          episodeId: episodeId
        }
      })
    }
  },
}
</script>

<style lang="css" scoped>
</style>
